import { render, staticRenderFns } from "./kcp-cert.vue?vue&type=template&id=38b112d8&"
import script from "./kcp-cert.vue?vue&type=script&lang=js&"
export * from "./kcp-cert.vue?vue&type=script&lang=js&"
import style0 from "./kcp-cert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports